import { render, staticRenderFns } from "./ChannelPermissions.vue?vue&type=template&id=70191df7"
import script from "./ChannelPermissions.vue?vue&type=script&lang=js"
export * from "./ChannelPermissions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports